<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div class="col-lg-12">
    <GraphHeader
      :ppp-active-sessions="ppp_active_sessions"
      :refresh-loader="refresh_loader"
      :share-port-data="share_port_data"
      :id="id"
      @refresh="refresh"
      @set-edit="setEdit"
      @delete-popup="deletePopup"
    />
    
    <GraphTabs
      :active="active"
      :onu-realtime-loader="onu_realtime_loader"
      @tab-change="setActive"
    />

    <OverviewTab
      v-if="active === 1"
      :loading="ppp_active_sessions_loading || single_user_db_data_loading"
      :ppp-active-sessions="ppp_active_sessions"
      :single-user-db-data="single_user_db_data"
      :description="description"
      :total-rx="total_rx"
      :total-tx="total_tx"
      :olt-connect-olt-name="olt_connect__olt_name"
      :vendor="vendor"
      :temperature-onu="Temperature_onu"
      :last-update="last_update"
      :last-dereg-reason="last_dereg_reason"
      :alive-time="alive_time"
      :port-number="port_number"
      :down-count="down_count"
      :refresh-loader="refresh_loader"
      :chart-data="chartData"
      :loader="loader"
      :loadernew="loadernew"
      :dashboard-chart-data="dashoard_chart_data"
      :selected-index="seleced_index"
      @fetch-history-data="fetchHistoryData"
      @filer="filer"
    />

    <OnuRealtimeTab
      v-if="active === 2"
      :rtl-data="rtl_data"
      :rtl-epon-data="rtl_Epon_data"
      :rtl-cdata-data="rtl_Cdata_data"
      :rtl-cloude-data="rtl_cloude_data"
      :rtl-vsol-data="rtl_Vsol_data"
      :rtl-bdcom-epon-data="rtl_Bdcom_Epon_data"
      :rtl-gpon-cloude-data="rtl_Gpon_Cloude_data"
      :rtl-tbs-epon-data="rtl_Tbs_Epon_data"
      :onu-status="onu_status"
      :onu-realtime-loader="onu_realtime_loader"
      :port-number="port_number"
      :description="description"
      :temperature-onu="Temperature_onu"
      :last-dereg-reason="last_dereg_reason"
      :donutchart-data="donutchartData"
      :donutchart-data-middle="donutchartDataMiddle"
      :chart-options="donutchartOptions"
      @logs-popup-open="logs_popup = true"
    />

    <TasksTab
      v-if="active === 3 || active === 2"
      :donutchart-data="donutchartData"
      :chart-options="donutchartOptions"
      :chart-data="chartData"
    />

    <!-- Popups -->
    <NewPppoePopup
      :visible="new_popup"
      :new-pppoe-data="new_pppoe_data"
      :chart-data="chartData"
      :loader="loader"
      :loadernew="loadernew"
      :dashoard-chart-data="dashoard_chart_data"
      :seleced-index="seleced_index"
      @close="popup_close"
      @filter="filer"
    />
    <EditPopup
      :visible="epon_popup"
      :form-data="formData"
      :loading="loading"
      @close="popup_close"
      @submit="submitForm"
    />

    <DeletePopup
      :visible="delete_popup"
      @close="popup_close"
      @confirm="deleteItem"
    />

    <LogsPopup
      :visible="logs_popup"
      :rtl-epon-data="rtl_Epon_data"
      :rtl-data="rtl_data"
      @close="logs_popup_close"
    />

    <MultipleListPopup
      :visible="multiple_list_popup"
      :multiple-data="multiple_data"
      @close="logs_popup_close"
      @delete="deletePopup"
    />

    <DeletePopup
      :visible="delete_popup_pppoe"
      @close="popup_close"
      @confirm="deleteItemPPPOE"
    />

    <!-- Add History Popup -->
    <HistoryPopup
      v-model="history_popup"
      :pppoe-id="pppoe_id"
      :history-data="historyData"
    />
  </div>
</template>
<script>
// import getPPOEGrapgData from "../services/pppoe-graph-data.service";
import getLogsDateList from "../services/get-logs-date";
// import sequreRtData from "../services/sequre-rt-data.service";
import getStatusData from "../services/status.service";
// import getReloadServer from "../services/realod-server.service";
import getRefreshServer from "../services/refresh-server.service";
import getSingleUserDb from "../services/get-single-user-db.service";
import getSharePortCount from "../services/share-port-count";
import showSwal from "/src/mixins/showSwal.js";
import deleteData from "../services/delete-data.service";
import updatesData from "../services/update-data.service";
import { useRtlApi } from "../services/rtl-olt.service";
import { useRefreshOltApi } from "../services/refresh-olt.service";
import { usePortInfoApi } from "../services/port-info.service";
import HistoryPopup from "@/components/HistoryPopup.vue";
import { useSearchApi } from "../services/search.service";
import { usePortInfoVsolGponApi } from '../services/port-info-vsol-gpon.service';
import { usePortInfoVsolEponApi } from '../services/port-info-vsol-epon.service';
import { usePortInfoGponCDATACLODEV1Api } from '../services/port-info-gpon-cdata-clode-v1.service';
import { usePortInfoTbsEponApi } from '../services/port-info-tbs-epon.service';
import GraphHeader from './components/graph/GraphHeader.vue';
import GraphTabs from './components/graph/GraphTabs.vue';
import OverviewTab from './components/graph/OverviewTab.vue';
import OnuRealtimeTab from './components/graph/OnuRealtimeTab.vue';
import TasksTab from './components/graph/TasksTab.vue';
import NewPppoePopup from './components/graph/NewPppoePopup.vue';
import EditPopup from './components/graph/EditPopup.vue';
import DeletePopup from './components/graph/DeletePopup.vue';
import LogsPopup from './components/graph/LogsPopup.vue';
import MultipleListPopup from './components/graph/MultipleListPopup.vue';

const { getDownHistryList } = useSearchApi();

export default {
  name: "Graph",
  components: {
    HistoryPopup,
    GraphHeader,
    GraphTabs,
    OverviewTab,
    OnuRealtimeTab,
    TasksTab,
    NewPppoePopup,
    EditPopup,
    DeletePopup,
    LogsPopup,
    MultipleListPopup
  },

  data() {
    return {
      rtl_Vsol_data: {},
      rtl_cloude_data: [],
      rtl_Cdata_data: [],
      rtl_Bdcom_Epon_data: {},
      rtl_Gpon_Cloude_data: {},
      rtl_Tbs_Epon_data: {},
      donutchartData: {
        datasets: [
          {
            label: "My Dataset",
            data: [0, 0, 100],
            backgroundColor: ["#adff2f", "#ffff00"],
            hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
          },
        ],
      },
      donutchartDataMiddle: {
        datasets: [
          {
            label: "My Dataset",
            data: [0, 0, 100],
            backgroundColor: ["#adff2f", "#ffff00"],
            hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
          },
        ],
      },
      donutchartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
          },
        },
      },
      active: 1,
      description_data: [],
      single_user_db_data: [],
      // #############################
      // ######################
      single_user_db_data_loading: true,
      ppp_active_sessions_loading: true,

      // #############################
      // #######################

      share_port_data: [],
      dashoard_chart_data: [],
      // sequre_rt_data: [],
      multiple_data: [],
      status: "",
      Temperature_onu: "",
      vendor: null,
      olt_connect__olt_name: "",
      last_update: null,
      description: null,
      last_dereg_reason: null,
      alive_time: null,
      port_number: null,
      id: null,
      olt_connect__oltid: "",
      chartData: null,
      seleced_index: "All",
      loader: true,
      loading: false,
      epon_popup: false,
      new_popup: false,
      loadernew: false,
      refresh_loader: false,
      logs_popup: false,
      pppoe: this.$route.params.pppoe,
      delete_popup: false,
      delete_popup_pppoe: false,
      delete_id_pppoe: "",
      multiple_list_popup: false,
      ppp_active_sessions: [],
      total_rx: null,
      total_tx: null,
      delete_id: "",
      down_count: "",
      formData: {
        PPPOE_ID: "",
        port_number: "",
      },
      onu_status: false,
      rtl_data: [],
      rtl_Epon_data: [],
      new_pppoe_data: [],
      history_popup: false,
      historyData: [],
      pppoe_id: this.$route.params.pppoe,
      olt_brand:'',
      ecom_portid:null,
      onu_realtime_loader:false
    };
  },

  async mounted() {
    await this.getPPOEGrapg();
    this.getCurrentDateData();
    this.getSingleUserDbData();
    this.getNewPPPOEData();
    this.fetchDownCountData();
  },

  watch: {
    "$route.params.pppoe": function (newVal) {
      this.pppoe = newVal;
      window.location.reload();
    },

    rtl_Vsol_data: {
    handler(newData) {
      if (newData.opticalinfo) {
        const rxPower = parseFloat(newData.opticalinfo.rx_optical_level_onu) || 0;
        this.donutchartDataMiddle.datasets[0].data[1] = Math.abs(rxPower);
        this.donutchartDataMiddle.datasets[0].data[2] = 100 - Math.abs(rxPower);
      }
    },
    deep: true
  },

    rtl_data: {
      handler(newData) {
        this.donutchartData.datasets[0].data[1] = Array.isArray(
          newData.Deactivation_Logs
        )
          ? newData.Deactivation_Logs.length
          : 0;

        this.donutchartData.datasets[0].data[2] =
          100 -
          (Array.isArray(newData.Deactivation_Logs)
            ? newData.Deactivation_Logs.length
            : 0);
      },
      deep: true,
    },

    rtl_Epon_data: {
      handler(newData) {
        this.donutchartData.datasets[0].data[1] = Array.isArray(
          newData?.upldown_logs
        )
          ? newData?.upldown_logs.length
          : 0;

        this.donutchartData.datasets[0].data[2] =
          100 -
          (Array.isArray(newData?.upldown_logs)
            ? newData?.upldown_logs.length
            : 0);

        this.donutchartDataMiddle.datasets[0].data[1] = newData?.optical_diagnose?.data?.receive_power.split(
          "dBm"
        )[0];

        this.donutchartDataMiddle.datasets[0].data[2] =
          100 - newData?.optical_diagnose?.data?.receive_power.split("dBm")[0];
      },
      deep: true,
    },
  },

  methods: {
    async fetchRtlVsolEponData(olt_id, port_number) {
  this.onu_realtime_loader = true;
  
  try {
    const response = await usePortInfoVsolEponApi().getSingleOnuData(port_number, olt_id);
    
    console.log('VSOL EPON API Response:', response); // Debug log
    
    if (response && response.single_onudata) {
      this.rtl_Vsol_data = response;
      
      // Update donut chart with distance or other relevant metrics
      if (response.single_onudata.distance_m) {
        const distance = parseInt(response.single_onudata.distance_m) || 0;
        this.donutchartDataMiddle.datasets[0].data = [
          0, 
          Math.min(distance, 100), 
          Math.max(0, 100 - Math.min(distance, 100))
        ];
      }
    } else {
      throw new Error('Invalid response from VSOL EPON API');
    }
    
  } catch (error) {
    console.error('VSOL EPON Error:', error);
    this.rtl_Vsol_data = {};
    
    showSwal.methods.showSwal({
      type: "error",
      message: "Failed to fetch VSOL EPON ONU data: " + error.message,
    });
  }
  
  this.onu_realtime_loader = false;
},
    async fetchRtlVsolData(olt_id, port_number) {
  this.onu_realtime_loader = true;
  
  try {
    const response = await usePortInfoVsolGponApi().getSingleOnuData(port_number, olt_id);
    
    console.log('VSOL API Response:', response); // Add this for debugging
    
    if (response && response.ok) {
      this.rtl_Vsol_data = response;
      
      // Update donut chart with RX optical level
      if (response.opticalinfo?.rx_optical_level_onu) {
        const rxPower = Math.abs(parseFloat(response.opticalinfo.rx_optical_level_onu));
        this.donutchartDataMiddle.datasets[0].data = [
          0, 
          rxPower, 
          Math.max(0, 100 - rxPower)
        ];
      }
    } else {
      throw new Error('Invalid response from VSOL API');
    }
    
  } catch (error) {
    console.error('VSOL Error:', error);
    this.rtl_Vsol_data = {};
    
    showSwal.methods.showSwal({
      type: "error",
      message: "Failed to fetch VSOL ONU data: " + error.message,
    });
  }
  
  this.onu_realtime_loader = false;
},
    formatdata(data) {
      return (this.splitData = data.split(","));
    },
    async deletePopupPppoe(id) {
      this.delete_id_pppoe = id;
      this.delete_popup_pppoe = true;
    },

    async deleteItemPPPOE() {
      this.loading = true;
      try {
        await deleteData.deleteData(this.delete_id_pppoe);

        showSwal.methods.showSwal({
          type: "success",
          message: "Deleted Successfully!",
        });

        this.delete_popup_pppoe = false;

        await this.getCurrentDateData();
        await this.getPPOEGrapg();
        await this.getSingleUserDbData();
        await this.getNewPPPOEData();
      } catch (error) {
        this.loading = false;
        console.error("Error on delete:", error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to delete!",
        });
      }
    },

    //RtL Data
    async fetchDownCountData(id, port) {
      try {
        const response = await useRtlApi().downCount(this.pppoe);
        this.down_count = response.down_count

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchRtlBdcomData(id, port) {
      try {
        let response = await useRtlApi().getBdcomGponData(id, port.split("/")[1]);       
        
        this.rtl_data = response;
        this.donutchartData.datasets[0].data[1] = this.rtl_data.Deactivation_Logs.length;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchRtlEponData(id, port) {
      try {
        const response = await useRtlApi().getAviesEponData(
          id,
          port.split("/")[1]
        );
        this.rtl_Epon_data = response;
        // this.donutchartData.datasets[0].data[1] = this.rtl_data.Deactivation_Logs.length;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchRtlBdcomEponData(id, port) {
      this.onu_realtime_loader = true;
      try {
        
        const response = await useRtlApi().getBdcomEponData(id, port);
        
        console.log('BDCOM EPON API Response:', response);
        
        if (response && response.success && response.results && response.results.length > 0) {
          const result = response.results[0];
          
          // Handle different data formats:
          // 1. Array of objects (interface state data)
          // 2. Array of strings (ONU interface basic info - "Key : Value" format)
          let parsedData = {};
          let interfaceData = [];
          
          if (result.data && Array.isArray(result.data)) {
            // Check if first item is an object or string
            if (result.data.length > 0 && typeof result.data[0] === 'object' && result.data[0] !== null) {
              // Array of objects - store as interface data
              interfaceData = result.data;
              
              // Find EPON interfaces and merge them into parsedData
              const eponInterfaces = result.data.filter(item => 
                item.Interface && item.Interface.toLowerCase().includes('epon')
              );
              
              // If we have EPON interfaces, use the first one that's connected, otherwise use the first one
              const eponInterface = eponInterfaces.find(item => 
                item['Connection state'] && item['Connection state'].toLowerCase() === 'connect'
              ) || eponInterfaces[0] || result.data[0];
              
              if (eponInterface) {
                parsedData = { ...eponInterface };
              }
            } else {
              // Array of strings - parse "Key : Value" format
              result.data.forEach((item) => {
                if (typeof item === 'string' && item.includes(':')) {
                  const colonIndex = item.indexOf(':');
                  if (colonIndex > 0) {
                    const key = item.substring(0, colonIndex).trim();
                    const value = item.substring(colonIndex + 1).trim();
                    // Only add if value is not empty and doesn't contain config prompts
                    if (value && !value.includes('8_PORT_BDCOM_OLT') && !value.includes('config#')) {
                      parsedData[key] = value;
                    }
                  }
                }
              });
            }
          }
          
          // Update donut chart with received power (try different possible keys)
          const rxPowerKeys = ['received power(DBm)', 'Received Power', 'Rx Power', 'receive_power', 'Received power'];
          let rxPower = null;
          for (const key of rxPowerKeys) {
            if (parsedData[key]) {
              const powerValue = parsedData[key].toString().replace(/dBm/gi, '').trim();
              rxPower = Math.abs(parseFloat(powerValue)) || 0;
              if (rxPower > 0) break;
            }
          }
          // Also check in interface data
          if (!rxPower && interfaceData.length > 0) {
            const eponInterface = interfaceData.find(item => 
              item.Interface && item.Interface.toLowerCase().includes('epon')
            ) || interfaceData[0];
            if (eponInterface) {
              for (const key of rxPowerKeys) {
                if (eponInterface[key]) {
                  const powerValue = eponInterface[key].toString().replace(/dBm/gi, '').trim();
                  rxPower = Math.abs(parseFloat(powerValue)) || 0;
                  if (rxPower > 0) break;
                }
              }
            }
          }
          
          if (rxPower !== null && rxPower > 0) {
            this.donutchartDataMiddle.datasets[0].data[1] = rxPower;
            this.donutchartDataMiddle.datasets[0].data[2] = Math.max(0, 100 - rxPower);
          }
          
          // Store the data along with device info - ensure ok flag is set
          this.rtl_Bdcom_Epon_data = {
            ...result,
            ok: result.ok !== undefined ? result.ok : true, // Ensure ok is set
            parsedData: parsedData,
            interfaceData: interfaceData,
            data: result.data // Keep original data for reference
          };
          
          console.log('BDCOM EPON Data Structure:', {
            ok: this.rtl_Bdcom_Epon_data.ok,
            hasDevice: !!this.rtl_Bdcom_Epon_data.device,
            parsedDataKeys: Object.keys(parsedData),
            interfaceDataLength: interfaceData.length,
            device: result.device
          });
        } else {
          console.warn('BDCOM EPON - Invalid response structure:', response);
          // Set empty data but with ok: false so UI can show loading/error state
          this.rtl_Bdcom_Epon_data = {
            ok: false,
            parsedData: {},
            interfaceData: [],
            data: []
          };
        }
        
        this.onu_realtime_loader = false;
      } catch (error) {
        console.error('BDCOM EPON Error:', error);
        // Set data structure even on error so UI condition can evaluate
        this.rtl_Bdcom_Epon_data = {
          ok: false,
          parsedData: {},
          interfaceData: [],
          data: [],
          error: error.message
        };
        this.onu_realtime_loader = false;
        
        // Only show error if it's a real error, not just missing data
        if (error.response && error.response.status !== 404) {
          showSwal.methods.showSwal({
            type: "error",
            message: "Failed to fetch BDCOM EPON data: " + (error.message || "Unknown error"),
          });
        }
      }
    },
    async fetchRtlCdataData(id, port) {
      
      this.onu_realtime_loader = true
      try {
        const response = await useRtlApi().getBdCdataData(
          id,
          port
        );
        this.rtl_Cdata_data = response;
      } catch (error) {
        
        this.onu_realtime_loader = false
        console.error("Error fetching data:", error);
      }
      
        this.onu_realtime_loader = false
    },
    async fetchRtlCloudeData(id, port) {
      
      this.onu_realtime_loader = true
      try {
        const response = await useRtlApi().getEponCloudeData(
          id,
          port
        );
        this.rtl_cloude_data = response;
      } catch (error) {
        
        this.onu_realtime_loader = false
        console.error("Error fetching data:", error);
      }
      
        this.onu_realtime_loader = false
    },
    async fetchRtlGponCloudeData(id, port) {
      this.onu_realtime_loader = true;
      try {
        const response = await usePortInfoGponCDATACLODEV1Api().getSingleOnuData(port, id);
        
        console.log('GPON CDATA-CLOUDE-V1 API Response:', response);
        
        if (response) {
          this.rtl_Gpon_Cloude_data = response;
          
          // Update donut chart with RxPower
          if (response.RxPower !== null && response.RxPower !== undefined && response.RxPower !== 0) {
            const rxPower = Math.abs(parseFloat(response.RxPower)) || 0;
            this.donutchartDataMiddle.datasets[0].data = [
              0, 
              Math.min(rxPower, 100), 
              Math.max(0, 100 - Math.min(rxPower, 100))
            ];
          }
        } else {
          throw new Error('Invalid response from GPON CDATA-CLOUDE-V1 API');
        }
        
      } catch (error) {
        console.error('GPON CDATA-CLOUDE-V1 Error:', error);
        this.rtl_Gpon_Cloude_data = {};
        
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to fetch GPON CDATA-CLOUDE-V1 ONU data: " + error.message,
        });
      }
      
      this.onu_realtime_loader = false;
    },
    async fetchRtlTbsEponData(olt_id, port_number) {
      this.onu_realtime_loader = true;
      try {
        // Parse port_number to extract ponPortName and onuId
        // Expected formats: "pon5:1", "EPON0/5:1", "5:1", etc.
        let ponPortName = '';
        let onuId = '';
        
        // Try to parse different port number formats
        if (port_number.includes(':')) {
          const parts = port_number.split(':');
          onuId = parts[parts.length - 1]; // Last part is onuId
          
          // Extract pon port name from the first part
          const ponPart = parts[0];
          
          // Check if it's already in "ponX" format
          if (ponPart.toLowerCase().startsWith('pon')) {
            ponPortName = ponPart.toLowerCase();
          } else {
            // Try to extract from formats like "EPON0/5" or "5"
            const match = ponPart.match(/(?:EPON\d+\/)?(\d+)/);
            if (match) {
              ponPortName = `pon${match[1]}`;
            } else {
              // Fallback: use the whole ponPart
              ponPortName = ponPart.toLowerCase().startsWith('pon') ? ponPart.toLowerCase() : `pon${ponPart}`;
            }
          }
        } else {
          // If no colon, try to extract from formats like "pon5" or "5"
          if (port_number.toLowerCase().startsWith('pon')) {
            ponPortName = port_number.toLowerCase();
            onuId = '1'; // Default to 1 if not specified
          } else {
            const match = port_number.match(/(\d+)/);
            if (match) {
              ponPortName = `pon${match[1]}`;
              onuId = '1'; // Default to 1 if not specified
            } else {
              throw new Error(`Invalid port number format: ${port_number}`);
            }
          }
        }
        
        console.log('TBS EPON - Parsed:', { ponPortName, onuId, originalPort: port_number });
        
        const response = await usePortInfoTbsEponApi().getOnuRealtime(olt_id, ponPortName, onuId);
        
        console.log('TBS EPON API Response:', response);
        
        if (response && response.data) {
          this.rtl_Tbs_Epon_data = response;
          
          // Update donut chart if distance is available
          if (response.data.getPortOnuOpticalOne && response.data.getPortOnuOpticalOne.distance) {
            const distance = parseInt(response.data.getPortOnuOpticalOne.distance) || 0;
            this.donutchartDataMiddle.datasets[0].data = [
              0, 
              Math.min(distance, 100), 
              Math.max(0, 100 - Math.min(distance, 100))
            ];
          }
        } else {
          throw new Error('Invalid response from TBS EPON API');
        }
        
      } catch (error) {
        console.error('TBS EPON Error:', error);
        this.rtl_Tbs_Epon_data = {};
        
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to fetch TBS EPON ONU data: " + error.message,
        });
      }
      
      this.onu_realtime_loader = false;
    },
    async checkRtlBdcomData(id) {
  try {
    const response = await useRtlApi().checkUiLogic(id);
    
    console.log('OLT Response:', response); // Debug log
    
    if (response.olt_modes == "GPON" && response.olt_brands == "BDCOM") {
      this.onu_status = true;
      await this.fetchRtlBdcomData(id, this.port_number);
    } else if (response.olt_modes == "EPON" && response.olt_brands == "BDCOM") {
      this.onu_status = true;
      await this.fetchRtlBdcomEponData(id, this.port_number);
    } else if (response.olt_modes == "EPON" && response.olt_brands == "AVIES") {
      this.onu_status = true;
      await this.fetchRtlEponData(id, this.port_number);
    } else if (response.olt_modes == "EPON" && response.olt_brands == "CDATA-V1.2") {
      this.onu_status = true;          
      await this.fetchRtlCdataData(this.olt_connect__oltid, this.ecom_portid);
    } else if (response.olt_modes == "EPON" && response.olt_brands == "CDATA-CLOUDE-EPON") {
      this.onu_status = true;          
      await this.fetchRtlCloudeData(id, this.port_number);
    } else if (response.olt_modes == "GPON" && response.olt_brands == "VSOL") {
      this.onu_status = true;
      await this.fetchRtlVsolData(id, this.port_number);
    } else if (response.olt_modes == "EPON" && response.olt_brands == "VSOL") { // ADD THIS CONDITION
      this.onu_status = true;
      await this.fetchRtlVsolEponData(id, this.port_number);
    } else if (response.olt_modes == "GPON" && response.olt_brands == "CDATA-GPON-CLOUDE-V1") {
      this.onu_status = true;
      await this.fetchRtlGponCloudeData(id, this.port_number);
    } else if (response.olt_modes == "EPON" && response.olt_brands == "TBS-EP8X4G8") {
      this.onu_status = true;
      await this.fetchRtlTbsEponData(id, this.port_number);
    } else {
      showSwal.methods.showSwal({
        type: "error",
        message: "404 Not Found",
      });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
},

    setActive(value) {
      if (this.olt_connect__oltid) {
        this.active = value;
        this.checkRtlBdcomData(this.olt_connect__oltid);
      } else {
        showSwal.methods.showSwal({
          type: "error",
          message: "Olt Id Not Found. Please Wait!",
        });
      }
    },
    logs_popup_close() {
      this.logs_popup = false;
      this.multiple_list_popup = false;
    },

    async getCurrentDateData() {
      // Wait for dashoard_chart_data to be loaded
      if (!this.dashoard_chart_data || this.dashoard_chart_data.length === 0) {
        return;
      }

      const today = new Date();
      const options = { day: "2-digit", weekday: "short" };
      const todayFormatted = today
        .toLocaleDateString("en-US", options)
        .replace(" ", ", ");

      // Find the index for today's date
      const todayIndex = this.dashoard_chart_data.findIndex(
        (item) => item.date === todayFormatted
      );

      if (todayIndex >= 0) {
        // Use filer to filter for today's data, but don't re-fetch
        const filteredData = this.dashoard_chart_data.filter(
          (item) => item.date === todayFormatted
        );

        this.seleced_index = todayIndex;

        // Flatten the nested structure to extract data
        this.description_data = filteredData.flatMap((dateObj) =>
          dateObj.data.map((item) => Number(item.description))
        );

        // Prepare chart data
        this.chartData = {
          labels: filteredData.flatMap((dateObj) =>
            dateObj.data.map(
              (item) => `${item.last_update_formatted} (${item.description})`
            )
          ),
          datasets: [
            {
              label: "-dBm",
              data: this.description_data,
            },
          ],
        };
        this.loadernew = true;
      } else {
        // Today's date not found, keep all data (already set by getPPOEGrapg)
        this.seleced_index = "All";
        this.loadernew = true;
      }
    },

    async filer(filterDate, index) {
      this.chartData = null;
      if (filterDate == "All") {
        this.getPPOEGrapg();
        this.seleced_index = index;
      } else {
        this.dashoard_chart_data = await getLogsDateList.getLogsDateList(
          this.pppoe
        );
        const filteredData = this.dashoard_chart_data?.filter(
          (item) => item.date === filterDate
        );

        //Mached Index
        this.seleced_index = this.dashoard_chart_data?.findIndex(
          (item) => item.date === filterDate
        );

        // Flatten the nested structure to extract data
        this.description_data = filteredData?.flatMap((dateObj) =>
          dateObj.data.map((item) => Number(item.description))
        );

        // Prepare chart data
        this.chartData = {
          labels: filteredData?.flatMap((dateObj) =>
            dateObj.data.map(
              (item) => `${item.last_update_formatted} (${item.description})`
            )
          ),
          datasets: [
            {
              label: "-dBm",
              data: this.description_data,
            },
          ],
        };
      }
    },

    async submitForm(formData) {
      this.loading = true;
      try {
        // Use formData from parameter if provided, otherwise use this.formData
        const dataToSubmit = formData || this.formData;
        await updatesData.updatesData(dataToSubmit, this.single_data_id);
        await this.getPPOEGrapg();
        await this.getSingleUserDbData();
        await this.getNewPPPOEData();
        this.popup_close();

        showSwal.methods.showSwal({
          type: "success",
          message: "Updated Successfully!",
        });
      } catch (error) {
        this.loading = false;
        console.error("Error on update:", error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to Create!",
        });
      }
    },

    async deletePopup(id) {
      this.delete_id = id;
      this.delete_popup = true;
    },

    async deleteItem() {
      this.loading = true;
      try {
        await deleteData.deleteData(this.delete_id);
        showSwal.methods.showSwal({
          type: "success",
          message: "Deleted Successfully!",
        });
        this.delete_popup = false;
        this.getPPOEGrapg();
        this.getSingleUserDbData();
        this.getNewPPPOEData();
      } catch (error) {
        this.loading = false;
        console.error("Error on delete:", error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to delete!",
        });
      }
    },

    popup_close() {
      this.delete_popup_pppoe = false;
      this.delete_popup = false;
      this.epon_popup = false;
      this.formData.PPPOE_ID = "";
      this.formData.port_number = "";
      this.new_popup = false;
    },
    setEdit() {
      this.epon_popup = true;
      this.single_data_id = this.id;
      this.formData.PPPOE_ID = this.single_user_db_data.nowdb?.PPPOE_ID;
      this.formData.port_number = this.port_number;
    },

    async getPPOEGrapg() {
      this.ppp_active_sessions_loading = true;
      try {
        // this.dashoard_chart_data = await getPPOEGrapgData.getPPOEGrapgData(this.pppoe);
        this.dashoard_chart_data = await getLogsDateList.getLogsDateList(
          this.pppoe
        );

        // Flatten the nested structure to extract data
        this.description_data = this.dashoard_chart_data?.flatMap((dateObj) =>
          dateObj.data.map((item) => Number(item.description))
        );

        // Prepare chart data
        this.chartData = {
          labels: this.dashoard_chart_data?.flatMap((dateObj) =>
            dateObj.data.map(
              (item) => `${item.last_update_formatted} (${item.description})`
            )
          ),
          datasets: [
            {
              label: "-dBm",
              data: this.description_data,
            },
          ],
        };

        const response = await getStatusData.getStatusData(this.pppoe);
        this.ppp_active_sessions = response.ppp_active_sessions;

        this.status = response.status_is;
        this.olt_connect__oltid = response.olt_connect__oltid;
        this.ecom_portid = response.ecom_portid;
        this.Temperature_onu = response.Temperature_onu;
        this.last_dereg_reason = response.last_dereg_reason;
        this.alive_time = response.alive_time;
        this.port_number = response.port_number;
        this.vendor = response.vendor;
        this.olt_connect__olt_name = response.olt_connect__olt_name;
        this.description = response.description;
        this.last_update = response.last_update;
        this.id = response.id;
        this.total_rx = response.total_rx;
        this.total_tx = response.total_tx;

        this.ppp_active_sessions_loading = false;
      } catch (error) {
        console.error("Error fetching dashboard chart data:", error);
        this.ppp_active_sessions_loading = false;
      }
    },

    progressBarClass(port_count) {
      if (port_count >= 120) {
        return "bg-danger"; // red
      } else if (port_count >= 100) {
        return "bg-warning"; // medium
      } else {
        return "bg-success"; // normal
      }
    },
    progressBarClassEpon(port_count) {
      if (port_count >= 60) {
        return "bg-danger"; // red
      } else if (port_count >= 50) {
        return "bg-warning"; // medium
      } else {
        return "bg-success"; // normal
      }
    },
    

    async getSingleUserDbData() {
      this.single_user_db_data_loading = true;
      try {
        this.single_user_db_data = await getSingleUserDb.getSingleUserDb(
          this.pppoe
        );
        const response = await getSharePortCount.getSharePortCount(this.pppoe);

        if(response.error){     
          this.new_popup = true;
          this.new_pppoe_data = await useRtlApi().getPPPOE(this.pppoe);
        }

        this.share_port_data = response;

        this.single_user_db_data_loading = false;
      } catch (error) {
        // alert(error.response.data.error);
        this.single_user_db_data_loading = false;
        if("Multiple data entries found for the provided criteria" == error.response.data.error){
          try {
            const response = await useRtlApi().getMultiplePPPOE(this.pppoe);
            this.multiple_data = response;
            this.multiple_list_popup = true;
          } catch (error2) {
            console.error("Error fetching data:", error2);
          }
          console.error("Error fetching data:", error);
        }
      }
    },

    async getNewPPPOEData() {
      try {
          await getSharePortCount.getSharePortCount(this.pppoe);
      } catch (error) {
        if(error.response.data.error == "Data not found"){
          this.new_popup = true;
          this.new_pppoe_data = await useRtlApi().getPPPOE(this.pppoe);
        }
        
      }
    },

    async refresh() {
      try {
        this.refresh_loader = true;
        const response = await getRefreshServer.getRefreshServer(
          this.olt_connect__oltid,
          this.port_number.split("/")[1]
        );

        if(response.olt_modes == "EPON" && response.olt_brands == "CDATA-V1.2.4"){
           await useRefreshOltApi().refreshOlt(this.share_port_data?.ecom_portid, this.share_port_data?.olt_id);
        }
        if(response.olt_brands == "CDATA-V1.2"){
          this.olt_brand = "CDATA-V1.2";
           await usePortInfoApi().graphRefresh(this.ecom_portid);
        }

         showSwal.methods.showSwal({
            type: "success",
            message: "Data Updated Successfully",
          });

        await this.getPPOEGrapg();
        await this.getSingleUserDbData();
        await this.getNewPPPOEData();

        this.refresh_loader = false;
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Refresh Failed!",
        });
        this.refresh_loader = false;
        console.error("Error fetching data:", error);
      }
    },
    
    async fetchHistoryData(pppoe_id) {
      try {
        this.pppoe_id = pppoe_id || this.pppoe;
        const response = await getDownHistryList(this.pppoe_id);
        this.historyData = response.logs;
        this.history_popup = true;
      } catch (error) {
        console.error("Failed to fetch history data:", error);
      }
    },
  },
};
</script>
<style scoped>
.calendar {
  display: flex;
  justify-content: start;
  padding: 10px;
  background-color: #020024;
}
.calendar-item {
  width: 56px;
  height: 59px;
  background-color: #444;
  color: #fff;
  text-align: center;
  border-radius: 10px;
  padding: 4px;
  font-size: 14px;
  margin-right: 24px !important;
}
.calendar-item.selected {
  background-color: #98ffcc;
  color: black;
}
.calendar-day {
  font-size: 12px;
}
.calendar-date {
  font-size: 20px;
  font-weight: bold;
}

.shimmer-box {
  width: 100%;
  height: 100px; /* Adjust height as needed */
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 3.5s infinite linear;
  border-radius: 4px;
  margin-bottom: 10px; /* Adjust spacing */
}

.dark-mode .shimmer-box {
  background: linear-gradient(90deg, #586b836e 25%, #213550 50%, #34476736 75%);
  background-size: 200% 100%;
  animation: shimmer 3.5s infinite linear;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
